import React, { useEffect, useMemo, useState } from "react";
import { BsChevronDown } from "react-icons/bs";
import { Loading, LoadTable, OutsideClick } from "../../Components";
import { getBranchCode } from "../../../CommonFunction/GetUserInfo";
import { gql, useLazyQuery, useQuery } from "@apollo/client";
import { branchWithuserFilter } from "../../../Utils/AllPagesQuriesAndMutations";
import useFetchTableData from "../../custom_hooks/useFetchTableData";
import useProcessData from "../../../CommonFunction/ProcessData";
import HeaderDiv from "../../Components/HeaderDiv/HeaderDiv";
import { useDispatch } from "react-redux";
import "./ConsignmentNoteRagister.scss"

const queryfunction = (fields) => {
  const query = gql`
      query LrBookRegister {
        LrBookRegister {
          _id
          Is_Lock
          Type
          ${fields?.join(" ")}
        }
      }
      `;
  return query;
};

const ConsignmentNoteRagister = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [formdata, setFormData] = useState([]);
  const [BranchData, setBranchData] = useState([]);
  const [branchIdArr, setBranchIdArr] = useState([]);
  const [dropdownToggle, setDropdowmToggle] = useState(false);
  const [SelectAllBranch, setSelectAllBranch] = useState(false);
  const { data: branchData } = useQuery(branchWithuserFilter);
  const dispatch = useDispatch();
  const key = "Consignment_Note_Register";
  const config = useMemo(
    () => ({
      dataKey: "LrBookRegister",
      dateKeys: ["createdAt", "updatedAt"],
      deleteKeys: ["__typename"],
      dateKeysWithoutTime: ["Date"],
    }),
    []
  );

  const [fetchAccountGroup, { loading: queryLoading, error, data }] = useLazyQuery(queryfunction([]), {
    fetchPolicy: "network-only",
    onCompleted: () => {
      setIsLoading(false);
    },
    onError: () => {
      setIsLoading(false);
    },
    context: {
      headers: {
        "X-GraphQL-Server": "orion",
      },
    },
  });
  const { loading, TableHeaders } = useFetchTableData(queryfunction, fetchAccountGroup, setIsLoading, key);
  const { loading: processDataLoading } = useProcessData(data, setFormData, config, error);

  useEffect(() => {
    if (branchData) {
      setBranchData(branchData?.SearchBranchAsPerUserRightWithCompanyId);
    }
  }, [branchData]);

  useEffect(() => {
    const fetchBranchCode = async () => {
      try {
        const BranchData = await getBranchCode();
        setBranchIdArr((prev) => [...prev, BranchData?.BranchCode]);
      } catch (error) {
        console.error("Error fetching branch code:", error);
      }
    };

    fetchBranchCode();
  }, []);

  useEffect(() => {
    if (branchIdArr) {
      sessionStorage.setItem("UserSelectedBranch", JSON.stringify(branchIdArr));
      dispatch({ type: "Refetch", payload: true });
    }
  }, [branchIdArr]);

  useEffect(() => {
    return () => {
      sessionStorage.setItem("UserSelectedBranch", JSON.stringify({}));
    };
  }, []);

  const toggleBranchId = (branchId) => {
    setBranchIdArr((prev) => (prev.includes(branchId) ? prev.filter((id) => id !== branchId) : [...prev, branchId]));
  };
  const onDoubleClickRow =(data)=>{
   console.log(data?.Selected_Row?.Type
, "datadatadatadatadatadatadatadata", 'FTL_Consignment_Note')
    const payloadData = { key:data?.Selected_Row?.Type==="FTL" ? 'FTL_Consignment_Note':"Consignment_Note", data: data };
    dispatch({ type: "UNIQUE_TABLE_LIST", payload: payloadData });

  }
  return (
    <div className="MaindivCNR">
      <div>
        <HeaderDiv title="Consignment Note Register" TableKey={key} MoreActions={{ Is_Print: false }} />
        <div className="tabdiv">
          <div></div>
          <div>
            <div>
              <div className="CheckInput" onClick={() => setDropdowmToggle(true)}>
                <span>Select Branch</span>
                <BsChevronDown type="button" className={"icondown"} onClick={() => { }} />
              </div>
              {dropdownToggle && (
                <OutsideClick setToggled={() => setDropdowmToggle(false)}>
                  <div className="branchDD">
                    {BranchData && BranchData.length > 0 && (
                      <div>
                        <input
                          type="checkbox"
                          name=""
                          checked={SelectAllBranch}
                          id=""
                          onChange={(el) => {
                            let ids = BranchData.map((e) => e?.Unique_Id);
                            setBranchIdArr(ids);
                            setSelectAllBranch(el.target.checked);
                          }}
                        />
                        <div>Select All</div>
                      </div>
                    )}
                    {BranchData &&
                      BranchData.length > 0 &&
                      BranchData.map((e) => (
                        <div>
                          <input
                            type="checkbox"
                            name=""
                            checked={branchIdArr?.includes(e?.Unique_Id)}
                            id=""
                            onChange={(el) => toggleBranchId(e?.Unique_Id)}
                          />
                          <div>{e?.Name || ""}</div>
                        </div>
                      ))}
                  </div>
                </OutsideClick>
              )}
            </div>
          </div>
        </div>
      </div>
      {isLoading ? (
        <Loading />
      ) : !formdata?.length ? (
        <p className="DataNotAvailable">Data not Available</p>
      ) : (
        <>
          {(queryLoading || loading) && <div className="loader-line-div" />}

          <LoadTable
            data={formdata}
            loading={isLoading}
            error={error}
            title={key}
            colAddition={["Total_Number_Of_Boxes", "Total"]}
            onDoubleClick={onDoubleClickRow}
            TableHeaders={TableHeaders}

          />
        </>
      )}
    </div>
  );
};

export default ConsignmentNoteRagister;
